import * as actions from '../constants';
import { removeOrganisationAndTeamToCookie } from '../helpers';
var initialState = {};
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case actions.USER_PRODUCT_ACCESS_SUCCESS:
      return action.payload;

    case actions.DECODE_TOKEN_FAILURE:
    case actions.REFRESH_TOKEN_FAILURE:
    case actions.LOG_OUT_SUCCESS:
      removeOrganisationAndTeamToCookie();
      return initialState;

    default:
      return state;
  }
}